module.exports = __webpack_public_path__ + "img/honour1.0704a901.png";